import { AuthorCard } from 'components/Author/AuthorCard';
import { Box } from 'components/Box';
import { CmsApiPagePost } from 'modules/cms/api/types/CmsApiPage';
import {
  CmsBodyContainer,
  CmsBodyContainerWidth,
} from 'modules/cms/components/Body/CmsBodyContainer';
import { CmsReactions } from 'modules/cms/components/Reactions/CmsReactions';
import { CmsTagList } from 'modules/cms/components/TagList';
import { useCmsApiPageHomePageMeta } from 'modules/cms/hooks';
import { useUserEnvironment } from 'modules/main/store/hooks/useUserEnvironment';

type Props = {
  content: CmsApiPagePost;
};

export function CmsBodyMainContentPostBelowBlocks({ content }: Props) {
  const { user } = useUserEnvironment();
  const { homePageUrl } = useCmsApiPageHomePageMeta({
    cmsApiPage: content,
  });

  return (
    <>
      {content.tags && content.tags.length > 0 ? (
        <Box mb={32}>
          <CmsBodyContainer $width={CmsBodyContainerWidth.NARROW_LAYOUT}>
            <CmsTagList
              homePageUrl={content.subsite.homePage?.url}
              tags={content.tags}
            />
          </CmsBodyContainer>
        </Box>
      ) : null}

      {content.author ? (
        <CmsBodyContainer $width={CmsBodyContainerWidth.NARROW_LAYOUT}>
          <AuthorCard
            author={content.author}
            homePageUrl={homePageUrl}
            postedDate={content.postedDate}
            showDate={content.showDate}
          />
        </CmsBodyContainer>
      ) : null}
      {user?.hasIdealistProfileFeature && content.hasReactions ? (
        <CmsBodyContainer $width={CmsBodyContainerWidth.NARROW_LAYOUT}>
          <CmsReactions contentId={content.id} />
        </CmsBodyContainer>
      ) : null}
    </>
  );
}
